import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { isAdvertorial } from '../../../advertorial/advertorial';
import FCLink from '../../../fc_link/fc_link';
import Eyebrow from '../../../eyebrow/eyebrow';

export default function RecircCard(props) {
  const { config, metadata, cardEvent } = props;
  const advertorial = isAdvertorial(metadata.tags);
  const setCardClasses = () => {
    const cardClasses = ['card', 'card--recirc'];

    if (advertorial) {
      cardClasses.push('card--advertorial');
    }

    return cardClasses.join(' ');
  };

  return (
    <article className={setCardClasses()} onClick={event => cardEvent(event)}>
      <FCLink
        to={get(metadata, 'link')}
        title={get(metadata, 'title')}
        config={config}
        externalLink={get(metadata, 'external')}
        targetWindow={get(metadata, 'targetWindow')}
      >
        <Eyebrow metadata={metadata} />
        <h2 className="card__title card__title--recirc">
          {get(metadata, 'title')}
        </h2>
      </FCLink>
    </article>
  );
}

RecircCard.defaultProps = {
  cardEvent: () => {}
};

RecircCard.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.shape({}).isRequired,
  cardEvent: PropTypes.func
};
